import "../css/main.scss";
import "@adyen/adyen-web/dist/adyen.css";
import Checkout from "./checkout.js";
import * as Sentry from "@sentry/browser";

if (import.meta.env.CO_SENTRY_ENABLED === "true") {
    Sentry.init({
        dsn: import.meta.env.CO_SENTRY_DSN,
        environment: import.meta.env.CO_SENTRY_ENV,
        // replaysOnErrorSampleRate: 0.2,
        // normalizeDepth: 6,
        sendDefaultPii: true,
        // eslint-disable-next-line import/namespace
        integrations: [
            Sentry.httpClientIntegration(),
            Sentry.extraErrorDataIntegration(), 
            // Sentry.captureConsoleIntegration()
        ]
    });
}

// FIX "Can't find variable: _AutofillCallbackHandler" - https://developers.facebook.com/community/threads/320013549791141/
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {};

document.addEventListener("DOMContentLoaded", () => {
    Checkout.init();
});
